import React from 'react';
import CustomButton from '../../CustomButton'
import './ComeceAgoraSection.css'

export function ComeceAgoraSection() {
    return (
        <section className="cta-section-client">
            <div className="cta-container-client">
                <div className="cta-icon-client">
                    <span className="material-icon">smartphone</span>
                </div>
                <h2 className="cta-title-client">Baixe agora e agende o primeiro banho</h2>
                <p className="cta-description-client">
                    Seu pet merece o melhor cuidado. Comece hoje mesmo!
                </p>
                <div className="cta-buttons-client">
                    <CustomButton
                        variant="contained"
                        sx={{
                            backgroundColor: '#FF914D',
                            color: '#FFFFFF',
                            padding: '12px 24px',
                            fontSize: '15px',
                            '&:hover': {
                                backgroundColor: '#e67e3d',
                            },
                        }}
                    >
                        <span className="material-icon">download</span>
                        Baixar para iOS
                    </CustomButton>

                    <CustomButton
                        variant="contained"
                        sx={{
                            fontSize: '15px',
                            padding: '12px 24px',
                        }}
                    >
                        <span className="material-icon">download</span>
                        Baixar para Android
                    </CustomButton>
                </div>
            </div>
        </section>
    )
}